import {NgModule} from '@angular/core';
import {EntityDataService, EntityServices} from '@ngrx/data';
import {SaleInvoiceConfigurationDataService} from './impl/service/ngrx/saleInvoiceConfigurationData.service';
import {SaleInvoiceRepository} from '../../impl/service/ngrx/saleInvoice.repository';

@NgModule({
    imports: []
})
export class SaleInvoiceConfigurationModule {
    constructor(entityDataService: EntityDataService,
                entityServices: EntityServices,
                repository: SaleInvoiceRepository,
                dataService: SaleInvoiceConfigurationDataService,
    ) {

        entityDataService.registerServices({
            SaleInvoiceConfiguration: dataService,
        });

        entityServices.registerEntityCollectionServices({
            SaleInvoiceConfiguration: repository,
        });

        //  errorMessages.set('PRODUCT_SAVE_CODE_ALREADY_USED', 'Un produit avec ce code existe déjà');
    }
}
